import * as React from "react";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import UserStore from "state/user";
// Local components
import GoldInfo from "./components/GoldInfo";
import GoldGraph from "./components/GoldGraph";
// Shared components
import TitleBox from "components/TitleBox";
// UI frameworks
import { Row, Col, Alert } from "antd";
// Styles
import styles from "./index.module.scss";

interface IProps {
	user?: UserStore | any;
}

const GoldTransaction: React.FC<IProps> = (props: IProps) => {
	return (
		<>
			<Row>
				<TitleBox title="اطلاعات حساب کاربری" />
			</Row>
			{props.user.text && (
				<>
					<Alert
						type="warning"
						message={<b>{props.user.text}</b>}
						closeText={
							<Link to="/dashboard/profile">
								<b>ویرایش پروفایل</b>
							</Link>
						}
					/>
					<br />
				</>
			)}
			<Row className={styles["main-wrapper"]}>
				<Col md={17} xs={24}>
					<GoldGraph />
				</Col>
				<Col md={7} xs={24}>
					<GoldInfo />
				</Col>
			</Row>
		</>
	);
};

export default inject("user")(observer(GoldTransaction));
